import axios from "../../../axios/index.js";
import store from "../../../../store/store.js";
import router from "@/router";

let interceptorsInitialized = false;

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(accessToken) {
  subscribers = subscribers.filter(callback => callback(accessToken));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

export default {
  init() {
     if (interceptorsInitialized) return;
  interceptorsInitialized = true;

    store.commit("auth/SET_BEARER", localStorage.getItem("accessToken"));

    axios.interceptors.request.use(config => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    });

    axios.interceptors.response.use(
  response => response,
  error => {
    const config = error.config || {};
    const response = error.response;
    const originalRequest = config;
    const requestUrl = (originalRequest.url || "").toLowerCase();

    // لا تعمل refresh على login أو refresh نفسه
    const isAuthRequest =
      requestUrl.indexOf("/api/auth/dashboardlogin") !== -1 ||
      requestUrl.indexOf("/api/auth/refresh") !== -1;

    if (response && response.status === 401 && !isAuthRequest) {
      if (!isAlreadyFetchingAccessToken) {
        isAlreadyFetchingAccessToken = true;

        store.dispatch("auth/fetchAccessToken")
          .then(accessToken => {
            isAlreadyFetchingAccessToken = false;
            onAccessTokenFetched(accessToken);
          })
          .catch(() => {
            isAlreadyFetchingAccessToken = false;
            store.dispatch("auth/logout");
          });
      }

      return new Promise(resolve => {
        addSubscriber(accessToken => {
          originalRequest.headers.Authorization = "Bearer " + accessToken;
          resolve(axios(originalRequest));
        });
      });
    }

    return Promise.reject(error);
  }
);
  },

  login(userNameOrEmail, password) {
    return axios.post("/api/Auth/DashboardLogin", {
    userNameOrEmail: userNameOrEmail,
    password: password
    });
  },

  refreshToken() {
    return axios.post("/api/Auth/Refresh", {
      refreshToken: localStorage.getItem("refreshToken")
    });
  }
};
